import { render } from "./FolderBreadcrumb.vue?vue&type=template&id=653ced3e&scoped=true&ts=true"
import script from "./FolderBreadcrumb.vue?vue&type=script&lang=ts"
export * from "./FolderBreadcrumb.vue?vue&type=script&lang=ts"

import "./FolderBreadcrumb.vue?vue&type=style&index=0&id=653ced3e&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-653ced3e"]])

export default __exports__